import React from 'react';

const formatDate = (value) => {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('es-PE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

const formatQty = (value) =>
  parseFloat(value || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  });

const getStatusInfo = (requirement) => {
  if (requirement.status === 'cancelled') {
    return { label: 'Cancelado', color: '#ef4444' };
  }
  const pct = requirement.fulfillment_percent ?? 0;
  if (pct >= 100) return { label: 'Completado', color: '#2563eb' };
  if (pct > 0) return { label: 'Parcial', color: '#d97706' };
  return { label: 'Emitido', color: '#10b981' };
};

const RequirementPrintDocument = ({ requirement }) => {
  if (!requirement) return null;

  const status = getStatusInfo(requirement);
  const pct = requirement.fulfillment_percent ?? 0;

  return (
    <div className="print-container">
      <div className="header">
        <h1>Requerimiento</h1>
      </div>

      <div className="info-compact">
        <div className="info-compact-line">
          <span className="info-compact-label">Requerimiento:</span> {requirement.code}
          <span className="info-compact-sep"> · </span>
          <span className="info-compact-label">Fecha:</span> {formatDate(requirement.request_date)}
          {requirement.needed_by_date && (
            <>
              <span className="info-compact-sep"> · </span>
              <span className="info-compact-label">Fecha requerida:</span>{' '}
              {formatDate(requirement.needed_by_date)}
            </>
          )}
          <span className="info-compact-sep"> · </span>
          <span className="info-compact-label">Estado:</span>{' '}
          <span
            className="status-badge"
            style={{ backgroundColor: `${status.color}20`, color: status.color }}
          >
            {status.label}
          </span>
        </div>
        <div className="info-compact-line">
          <span className="info-compact-label">Proveedor:</span>{' '}
          {requirement.supplier?.name || 'Interno (sin proveedor)'}
          <span className="info-compact-sep"> · </span>
          <span className="info-compact-label">Avance:</span> {pct}%
          <span className="info-compact-sep"> · </span>
          <span className="info-compact-label">Ítems:</span> {requirement.items?.length || 0}
        </div>
      </div>

      <div className="items-card">
        <div className="items-title">Productos solicitados</div>
        <table className="items-table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Unidad</th>
              <th>Proyecto</th>
              <th className="num">Cant.</th>
            </tr>
          </thead>
          <tbody>
            {(requirement.items || []).map((item, index) => (
              <tr key={item.id ?? index}>
                <td>
                  <span className="product-name">{item.product?.name || '—'}</span>
                  {item.notes ? <div className="product-notes">Obs: {item.notes}</div> : null}
                </td>
                <td>{item.unit_of_measure || item.product?.unit_of_measure || '—'}</td>
                <td>
                  {item.project
                    ? `${item.project.code || ''}${item.project.code && item.project.name ? ' - ' : ''}${item.project.name || ''}`
                    : '—'}
                </td>
                <td className="num">
                  <strong>{formatQty(item.quantity)}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="print-footer-obs">
        <span className="print-obs-label">Observaciones:</span>
        {requirement.notes ? <span className="print-obs-text">{requirement.notes}</span> : null}
      </div>
    </div>
  );
};

export default RequirementPrintDocument;
